import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackSubscriptionCreated } from '../utils/openaiAds';

/**
 * Fires the OpenAI Ads "Subscription Created" event when Stripe
 * Checkout returns to /app/<product>?subscription=success.
 */
export default function OpenAiConversionBeacon() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search || window.location.search);
    if (params.get('subscription') !== 'success') return;
    trackSubscriptionCreated({ source: 'checkout_return' });
  }, [location.search]);

  return null;
}
